import table1 from 'assets/tableGame/1.webp';
import table2 from 'assets/tableGame/2.webp';
import table3 from 'assets/tableGame/3.webp';

export interface TableGame {
  id: number;
  name: string;
  image: string;
  route: string;
}

export const mockTableGames: TableGame[] = [
  {
    id: 1,
    name: 'BLACK JACK',
    image: table1,
    route: '/casino/categories/table_games?gameType=blackjack',
  },
  {
    id: 2,
    name: 'ROULETTE',
    image: table2,
    route: '/casino/categories/table_games?gameType=roulette',
  },
  {
    id: 3,
    name: 'BACCARAT',
    image: table3,
    route: '/casino/categories/table_games?gameType=baccarat',
  },
];
